import { Link } from 'react-router-dom';
import { Form } from 'antd';
import { isEmpty } from 'lodash';

import { TFieldProps } from 'types';

const { Item } = Form;

interface ILinkProps extends Pick<TFieldProps, 'link'> {
  value?: string;
}

const CustomLink = ({ value, link }: ILinkProps) => {
  if (Array.isArray(link) && link?.length) {
    return (
      <>
        {link.map((linkItem, index) => (
          <span key={linkItem.to}>
            {!!index && ', '}
            <Link
              to={linkItem.to}
              key={linkItem?.name}
            >
              {linkItem.name}
            </Link>
          </span>
        ))}
      </>
    );
  }

  if (!Array.isArray(link) && !isEmpty(link) && link?.external) {
    return (
      <a href={link.to} target='_blank' rel='noreferrer'>
        {link.name}
      </a>
    );
  }

  if (!Array.isArray(link) && !isEmpty(link)) {
    return (
      <Link to={link.to}>
        {link.name || value}
      </Link>
    );
  }

  return null;
};

export const FormLink = ({
  link,
  name,
  label,
  rules,
  hidden,
  tooltip,
  itemClassName,
}: Omit<TFieldProps, 'type'>) => (
  <Item
    name={name}
    rules={rules}
    label={label}
    hidden={hidden}
    tooltip={tooltip}
    labelAlign='left'
    className={itemClassName}
  >
    <CustomLink link={link} />
  </Item>
);
